import React, { useState } from 'react';

import { Box, useTheme, useMediaQuery, Grid, Typography } from '@mui/material';
import { Coupon } from './Coupon';
import { BrandConfirm } from './brand/BrandConfirm';
import { ButtonConfirm } from './ButtonConfirm';
import { DetailsConfirm } from './info/DetailsConfirm';
import { Collaborator } from './collaborator/Collaborator';
import { ModalPagoMensual } from '@modals/ModalPagoMensual';
import { Options } from '../../../../pages/Options';
import { TypePredicateKind } from 'typescript';
import { usePolicyStore } from '@store/policyStore';

interface RightCardI {
  setCouponStart: any;
}

export const RightCard = ({ setCouponStart }: RightCardI) => {
  const { breakpoints } = useTheme();
  const { policy } = usePolicyStore();
  //const { selectedPlan, paymentMode } = usePlansDataStore();
  const isMobile = useMediaQuery(breakpoints.down('sm'));
  const isTablet = useMediaQuery(breakpoints.down('md'));

  const [open, setOpen] = useState<boolean>(false);

  return (
    <Box
      padding={`${isMobile ? '0px' : '30px'}`}
      height={!isTablet ? 'inherit' : 950}
      width={isMobile ? '100%' : isTablet ? '90%' : '100%'}
      borderRadius={!isTablet ? '10px' : 2}
      style={{
        backgroundColor: 'white',
      }}
    >
      <DetailsConfirm />
      <Box
        borderRadius={2}
        marginTop={2}
        style={{
          backgroundColor: 'white',
        }}
      >
        <Box
          padding={isTablet ? 2 : 0}
          style={{
            borderRadius: '10px',
          }}
        >
          <Coupon setCouponStart={setCouponStart} />
          <Collaborator />
          {policy.codeCoupon.code !== '' && (
            <Box
              display="flex"
              flexDirection="column"
              justifyContent="left"
              marginTop={1}
              paddingBottom="25px"
              style={{
                borderBottomStyle: 'dashed',
                borderBottom: '1px dashed #5E6A71',
              }}
            >
              <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
                sx={{ background: '#F4F4F4', borderRadius: '4px', gap: '8px' }}
              >
                <Box
                  sx={{
                    my: '16px',
                    mx: '16px',
                  }}
                >
                  <span
                    style={{
                      font: 'Montserrat',
                      width: '600',
                      fontSize: '14px',
                    }}
                  >
                    <strong>Certificado de Regalo</strong>
                  </span>
                  <br />
                  <span
                    style={{
                      font: 'Montserrat',
                      width: '400',
                      fontSize: '12px',
                    }}
                  >
                    Recuerda que para obtener el certificado tienes que adquirir
                    el seguro en Plan Amplio en pago de contado
                  </span>
                </Box>
              </Grid>
            </Box>
          )}
          <BrandConfirm />
          <ButtonConfirm open={open} setOpen={setOpen} />
          <ModalPagoMensual open={open} setOpen={setOpen} />
        </Box>
      </Box>
    </Box>
  );
};
